import { useState } from "react";
import { SortDirection } from "../../../models/person.model";

export function useCVListFilters() {
    const [searchQuery, setSearchQuery] = useState("");
    const [availabilityFilterActive, setAvailabilityFilterActive] = useState(false);
    const [availabilityDays, setAvailabilityDays] = useState<number | null>(null);
    const [inactiveFilterActive, setInactiveFilterActive] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
    const [selectedLanguage, setSelectedLanguage] = useState<number | null>(null);
    const [selectedProficiency, setSelectedProficiency] = useState<number | null>(null);
    const [pageSize, setPageSize] = useState(20);
    const [pageIndex, setPageIndex] = useState(0);
    const [sortField, setSortField] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState(SortDirection.Ascending);

    const handleSortChange = (field: string) => {
        if (field === "none") {
            setSortField(null);
            setSortDirection(SortDirection.Ascending);
        } else if (sortField === field) {
            setSortDirection(
                sortDirection === SortDirection.Ascending
                    ? SortDirection.Descending
                    : SortDirection.Ascending
            );
        } else {
            setSortField(field);
            setSortDirection(SortDirection.Ascending);
        }
        setPageIndex(0);
    };

    const handlePageSizeChange = (value: string) => {
        const newSize = parseInt(value, 10);
        setPageSize(newSize);
        setPageIndex(0);
    };

    const handlePageChange = (newPage: number) => {
        setPageIndex(newPage - 1);
    };

    return {
        searchQuery,
        setSearchQuery,
        availabilityFilterActive,
        setAvailabilityFilterActive,
        availabilityDays,
        setAvailabilityDays,
        inactiveFilterActive,
        setInactiveFilterActive,
        selectedLocation,
        setSelectedLocation,
        selectedLanguage,
        setSelectedLanguage,
        selectedProficiency,
        setSelectedProficiency,
        pageSize,
        setPageSize,
        pageIndex,
        setPageIndex,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection,
        handleSortChange,
        handlePageSizeChange,
        handlePageChange,
    };
}

